import type { HTMLAttributes, ReactNode } from "react";

import { cx } from "./cx";
import styles from "./Card.module.css";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  selected?: boolean;
  children: ReactNode;
}

export function Card({
  interactive = false,
  selected = false,
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  return (
    <div
      className={cx(
        styles.card,
        interactive && styles.interactive,
        selected && styles.selected,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
